import React, { useEffect, useState } from 'react'
import axios from 'axios';
import Header from '../components/Header'
import slider from "../assets/Slider.png"
import '../../src/components/styles/Home.css';
import Footer from '../components/Footer';
import basuru_img from "../assets/CTA/Basuri2 1.jpg";

import { toast, ToastContainer } from "react-toastify";
import BookPanditForm from "../components/BookPanditForm";
import BookPanditPopupModal
from "../components/BookPanditPopupModal";


const PujaServices = () => {

   const [isMobile, setIsMobile] = useState(false);
  // States for API data
  const [pujaLists, setPujaLists] = useState({
    popularPujas: [], 
    yahanVaiva: [],
    specialEvent: [],
    upcomingPujas: [],
    doshanivaran: [],
    sharadhriti: []
  });
  const [loading, setLoading] = useState(true);

  // Fetch categories and then pujas by category
  useEffect(() => {
    const fetchPujasByCategory = async () => {
      try {
        setLoading(true);
        
        // Get selected city ID from localStorage
        const selectedCityId = localStorage.getItem('selectedCityId') || '';
        
        // Fetch all categories for the city
        const categoryResponse = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/v1/category`,
          { params: { loc: selectedCityId } }
        );
        
        const categoryList = categoryResponse.data.data.category_list || [];
        const allPujas = [];
        
        // Fetch pujas for each category
        for (const category of categoryList) {
          try {
            const pujaResponse = await axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/api/v1/puja/category/${category.id}/`
            );
            
            const categoryPujas = pujaResponse.data.data.puja_list || [];
            allPujas.push(...categoryPujas);
          } catch (err) {
            console.error(`Error fetching pujas for category ${category.id}:`, err.message);
          }
        }
        
        // Distribute pujas to different sections
        setPujaLists({
          popularPujas: allPujas.slice(0, 4),
          yahanVaiva: allPujas.slice(4, 8),
          specialEvent: allPujas.slice(8, 12),
          upcomingPujas: allPujas.slice(12, 16),
          doshanivaran: allPujas.slice(16, 20),
          sharadhriti: allPujas.slice(20, 24)
        });
        
        console.log("Pujas fetched successfully:", allPujas);
      } catch (err) {
        console.error("Error fetching categories:", err.message);
        // Fallback to empty arrays if API fails
        setPujaLists({
          popularPujas: [],
          yahanVaiva: [],
          specialEvent: [],
          upcomingPujas: [],
          doshanivaran: [],
          sharadhriti: []
        });
      } finally {
        setLoading(false);
      }
    };

    fetchPujasByCategory();
  }, []);

  // Testimonials (keep as hardcoded)
  const testimonials = [
    {
      id: 1,
      name: "An amazing service",
      image: require("../assets/pandits.png"),
      description: "Lorem ipsum dolor sit ametolil col consectetur adipiscing lectus a nunc mauris scelerisque sed egestas.",
      position: "CEO, Carryminati production house",
      quote: "Ajay Nagar",
    },
    {
      id: 2,
      name: "One of a kind service",
      image: require("../assets/pandits.png"),
      description: "Ultrices eros in cursus turpis massa tincidunt sem nulla pharetra diam sit amet nisl suscipit adipis.",
      position: "Developer, THYO India",
      quote: "Deepak Gupta",
    },
    {
      id: 3,
      name: "The best service",
      image: require("../assets/pandits.png"),
      description: "Convallis posuere morbi leo urna molestie at elementum eu facilisis sapien pellentesque habitant.",
      position: "CEO, Carryminati production house",
      quote: "Rajiv Ranjan",
    }
  ];

  // Helper component to render puja cards - Hide if no pujas
  const PujaSection = ({ title, subtitle, pujas }) => {
    // Don't render if no pujas available
    if (!pujas || pujas.length === 0) {
      return null;
    }

    return (
      <section className="mt-4">
        <div style={{ position: 'relative', paddingBottom: '10px' }} className="container">
          <div className="d-flex flex-column">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <h3 style={{ color: '#6B2A00', fontSize: '24px' }}>{title}</h3>
              <h3 style={{ color: '#E3952A', fontSize: '16px', cursor: 'pointer' }}>
                View All <i className="fas fa-chevron-right"></i>
              </h3>
            </div>
            <p style={{ color: '#E3952A', fontSize: '16px', marginTop: '5px', marginBottom: '5px' }}>
              {subtitle}
            </p>
            <div style={{
              width: '100%',
              height: '2px',
              marginTop: '5px',
              background: 'linear-gradient(to right, #8B5E3B 20%, #D3B8A1 20%)'
            }}></div>
          </div>
        </div>

        <div className="container d-flex justify-content-evenly flex-wrap gap-3 m-auto mt-4">
          {pujas.map((puja, index) => (
            <div key={index} className="event-card">
              <img 
                src={puja.puja_image} 
                alt={puja.puja_name} 
                className="event-img" 
              />
              <div className="event-content">
                <h2>{puja.puja_name}</h2>
                <p>{puja.description}</p>
                <button className="botton"   onClick={() => {

    window.dispatchEvent(
      new CustomEvent(
        "openBookPanditModal",
        {
          detail: {
            pujaId: puja.id
          }
        }
      )
    );

  }}
>Book A Pandit Today!</button>
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  };

  if (loading) {
    return (
      <>
        <Header />
        <div className="text-center mt-5 pt-5">
          <p>Loading pujas...</p>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <div className='mt-5'>
        <img src={slider} alt="" className=" img-fluid w-100" />
        
        <PujaSection 
          title="Popular Pujas" 
          subtitle="Explore the most popular and frequently booked Pujas."
          pujas={pujaLists.popularPujas}
        />
        
        <PujaSection 
          title="Yahan Vaiva & Occasion" 
          subtitle="Explore top booked Pujas for weddings, housewarmings, prosperity, and spiritual well-being."
          pujas={pujaLists.yahanVaiva}
        />
        
        <PujaSection 
          title="Puja on Special Event" 
          subtitle="Divine Blessings for Every Occasion!"
          pujas={pujaLists.specialEvent}
        />
        
        <PujaSection 
          title="Upcoming Pujas" 
          subtitle="Celebrate with Divine Blessings!"
          pujas={pujaLists.upcomingPujas}
        />
        
        <PujaSection 
          title="Dosha Nivaran Puja" 
          subtitle="Clear the Path, Embrace Divine Blessings with Dosha Nivaran Puja!"
          pujas={pujaLists.doshanivaran}
        />
        
        <PujaSection 
          title="Sharadh riti & Mukti Anusthan" 
          subtitle="Divine Rituals for Peace & Liberation!"
          pujas={pujaLists.sharadhriti}
        />
      </div>

      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-4">
            <span className="text-uppercase testinaction">Testimonials</span>
            <h2 className="fboldtext">What our clients say</h2>
          </div>

          <div className="row g-4">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="col-md-4 ">
                <div className="card border-1 shadow-sm p-5 rounded-4">
                  <div className="">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="rounded-circle me-3"
                      width="60"
                      height="60"
                      style={{ objectFit: "cover", border: '1px solid black' }}
                    />
                    <h5 className="textiname mb-3 mt-3">{testimonial.name}</h5>
                    <p className="psmaltext small mb-2">{testimonial.description}</p>
                  </div>

                  <blockquote className="mt-3 textinaeme">
                    {testimonial.quote}
                  </blockquote>
                  <p className="psmaltext small mb-0">{testimonial.position}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

         <div className={isMobile ? "bg-white" : "Container_img img-fluid"}>
    
    
            <BookPanditForm />
            <ToastContainer />
    
            </div>
      <Footer />
      <BookPanditPopupModal />
    </>
  )
}

export default PujaServices